import React, { useEffect, useRef } from "react";

// Adds .in-view to any [data-reveal] child once it intersects.
export default function RevealOnScroll({ children }) {
    const ref = useRef(null);

    useEffect(() => {
        const root = ref.current;
        if (!root) return;
        const els = root.querySelectorAll("[data-reveal]");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in-view");
                        observer.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
        );
        els.forEach((el) => {
            el.classList.add("reveal");
            observer.observe(el);
        });
        return () => observer.disconnect();
    }, []);

    return <div ref={ref}>{children}</div>;
}
